/**
 * Gallery Page
 */

import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { usePortal } from '../context/PortalContext';

const GalleryPage = () => {
  const { portal } = usePortal();
  // Array of { url, alt? } — see Portal.landingPage.gallery in the seed script for this business.
  const images = portal?.landingPage?.gallery || [];

  return (
    <>
      <Header />
      
      <main style={{ marginTop: '80px', minHeight: '80vh' }}>
        <section className="section">
          <div className="container">
            <div className="masthead">
              <span className="eyebrow">Our work</span>
              <h1>Gallery</h1>
              <p>See our work and events</p>
            </div>

            {images.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#666' }}>
                Gallery coming soon!
              </p>
            ) : (
              <div className="grid grid-4">
                {images.map((image, index) => (
                  <div key={index} style={styles.imageCard}>
                    <img 
                      src={image.url} 
                      alt={image.alt || `Gallery image ${index + 1}`}
                      style={styles.image}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

const styles = {
  imageCard: {
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
  },
  image: {
    width: '100%',
    height: '250px',
    objectFit: 'cover',
    display: 'block',
  },
};

export default GalleryPage;
